import { render, staticRenderFns } from "./PageNavbar.vue?vue&type=template&id=2c1b60b9&"
import script from "./PageNavbar.vue?vue&type=script&lang=js&"
export * from "./PageNavbar.vue?vue&type=script&lang=js&"
import style0 from "./PageNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports